import React from "react";
import { useTranslation } from "react-i18next";
import NewsCard from "component/news/NewsCard";
import { RelatedNewsSkeleton } from "component/news/NewsSkeletons.jsx";

const RelatedNewsPanel = ({ relatedNews, relatedLoading, relatedError }) => {
  const { t } = useTranslation();

  if (relatedLoading) {
    return <RelatedNewsSkeleton />;
  }

  if (relatedError) {
    return <div className="text-danger small">{relatedError}</div>;
  }

  if (!relatedNews || relatedNews.length === 0) {
    return <div className="text-white small">{t("news.noRelated")}</div>;
  }

  return (
    <div className="row g-4">
      {relatedNews.map((item, i) => {
        const similarityScore = Number(item.similarity_score ?? 0);
        const derivedProgress =
          typeof item.match_rate === "number"
            ? item.match_rate
            : Number.isFinite(similarityScore)
              ? Math.round(similarityScore * 100)
              : 0;

        return (
          <div
            className="col-md-6 col"
            key={item.id || item.display_article_id || `${i}`}
          >
            <NewsCard
              value={i + 1}
              viewMode="grid"
              title={item.title || item.seo_title || t("news.untitled")}
              summary={item.summary || ""}
              _id={item.id || item.display_article_id}
              progress={derivedProgress}
              image_url={item.image_url}
              sectors={item.sectors || []}
              created_at={item.created_at || item.recent_at}
              reading_time_minutes={item.reading_time_minutes}
            />
          </div>
        );
      })}
    </div>
  );
};

export default RelatedNewsPanel;
